
<div class="headerOne">
<div>
    <button style=" height: 32px;
    background-color: #3FA9F5;
    color: white;" class="confirm-ico-btn" mat-button routerLink="/catDevices"> {{'BACK' | translate}}</button>
</div>

<div>
    <p class="title">{{'title_save_device' | translate}}:</p>
</div>
</div>


<div class="divGeneral">
<!--<div style="text-align: right;">
    <button style=" height: 32px;
    background-color: red;
    color: white;" class="confirm-ico-btn" mat-raised-button (click)="openConfirmDialog()"> 
      <span class="fas fa-plus"></span> 
      {{'ACTIVE_ROW_DEVICE' | translate}}
  </button>
</div>-->
<form [formGroup]="saveDeviceForm" (ngSubmit)="onSubmit()">
    <div class="responsive-table-container">
<table class="table">
    <tr>
        <td colspan="2">
            <div>
                <mat-label>Image:</mat-label>
                <div class="image-upload-container">
                    <input type="file"  #fileInput (change)="onFileSelected($event)" hidden>
                    <mat-form-field appearance="outline">
                      <input matInput  placeholder="Select file" [value]="selectedFile?.name" readonly>
                      <button mat-button color="primary" matSuffix (click)="openFileInput()">Browse</button>
                    </mat-form-field>
                    <!--<button mat-raised-button color="primary" (click)="onUpload()">Upload</button>-->
                  </div>
            </div>
    
        </td>

        <td colspan="2">
            <div class="card">
       
              
                  
               
               <!--<img src="/assets/images/deviceManagement/IMG_CAMARA.png" alt="Image">-->
               <img [src]="arrayImages[0].imagefile" alt="Image" height="250" width="250">
              
                <div class="contenedor-flexbox">
                    <div class="notification">
                   
                    </div>
                  
                </div>
            </div>
        </td>
       
    </tr>
<tr>
    <td>   
    <div>
        <mat-label>{{'code' | translate}}:</mat-label>
        <div>
        <mat-form-field appearance="outline" class="mat-form-field-appearance-outline">
            
            <input matInput formControlName="Code" placeholder="Capture">
        </mat-form-field>
        </div>
    </div>
</td>
<td>
    <div>
        <mat-label>{{'name' | translate}}:</mat-label>
        <div>
        <mat-form-field appearance="outline">
            
            <input matInput formControlName="Name" placeholder="Capture">
        </mat-form-field>
        </div>
    </div>
</td>

    
 <td>   
    <!--<div>
        <mat-label>Type Device</mat-label>
        <div>
        <mat-form-field appearance="outline">
            
            <input matInput formControlName="TypeDevice" placeholder="Capture">

        </mat-form-field>
        </div>
    </div>-->
    <div>
        <mat-label>{{'serialNr' | translate}}:</mat-label>
        <div>
        <mat-form-field appearance="outline">
            
            <input matInput formControlName="SerialNr" placeholder="Capture">
        </mat-form-field>
    </div>
    </div>
    
</td>
<td>
    <div>
        <mat-label>{{'typeDevice' | translate}}:</mat-label>
        <div>
        <mat-form-field appearance="outline">
            <mat-select matInput formControlName="TypeId">
               
                <mat-option *ngFor="let type of arrayDeviceTypes" [value]="type.id">{{type.name}}</mat-option>
             
            </mat-select>
           
        </mat-form-field>
        </div>
    </div>
</td>
</tr>

<tr>
<td>
    <div>
        <mat-label>{{'brand' | translate}}:</mat-label>
        <div>
        <mat-form-field appearance="outline">
           
            <input matInput formControlName="Brand" placeholder="Capture">
        </mat-form-field>
        </div>
    </div>
</td>
<td>
    
    <div>
        <mat-label>{{'client' | translate}}:</mat-label>
        <div>
        <mat-form-field appearance="outline">
            
            <mat-select matInput [value]="0" formControlName="ClientId">
               
                <mat-option *ngFor="let client of clients" [value]="client.id">{{client.name}}</mat-option>
             
            </mat-select>
        </mat-form-field>
        </div>
    </div>
</td>
<td>
    <div>
        <mat-label>{{'ipAddress' | translate}}:</mat-label>
        <div>
        <mat-form-field appearance="outline">
            
            <input matInput formControlName="IpAddress" placeholder="Capture">
        </mat-form-field>
        </div>
    </div>
</td>
<td>
    <div>
        <mat-label>{{'deviceConfiguration' | translate}}:</mat-label>
        <div>
        <mat-form-field appearance="outline">
            
            <input matInput formControlName="DeviceConfigurationUrl" placeholder="Capture">
        </mat-form-field>
    </div>
    </div>
    
</td>  
</tr>
  <tr>
    <td>   
    <div>
        <mat-label>{{'username' | translate}}:</mat-label>
        <div>
        <mat-form-field appearance="outline">
            
            <input matInput formControlName="Username" placeholder="Capture">
        </mat-form-field>
    </div>
    </div>
</td>
<td>
    <div>
        <mat-label>{{'password' | translate}}:</mat-label>
        <div>
        <mat-form-field appearance="outline">
            
            <input matInput formControlName="Password" placeholder="Capture" type="password">
        </mat-form-field>
    </div>
    </div>
</td>
<td>
    <div>
        <mat-label>{{'model' | translate}}:</mat-label>
        <div>
        <mat-form-field appearance="outline">
            
            <input matInput formControlName="Model" placeholder="Capture">
        </mat-form-field>
    </div>
    </div>
</td>
<td>
    <div>
        <mat-label>{{'location' | translate}}:</mat-label>
        <div>
        <mat-form-field appearance="outline">
            
            <mat-select matInput [value]="0" formControlName="LocationId">
               
                <mat-option *ngFor="let item of arrayLocations" [value]="item.id">{{item.name}}</mat-option>
             
            </mat-select>
        </mat-form-field>
        </div>
    </div>
</td>
</tr>
<tr>
    <td>
        <div>
            <mat-label>{{'DISABLED_DEVICE' | translate}} / {{'ENABLED_DEVICE' | translate}}</mat-label>
            <div>

                <mat-slide-toggle formControlName="IsEnabled"
          class="example-margin"
          [checked]="true"
          [disabled]="false">
        
      </mat-slide-toggle>
            <!--<mat-form-field appearance="outline">
                
                <mat-select matInput [value]="0" formControlName="IsEnabled">
                   
                    <mat-option [value]="true">{{'ENABLED_DEVICE' | translate}}</mat-option>
                    <mat-option [value]="false">{{'DISABLED_DEVICE' | translate}}</mat-option>
                 
                </mat-select>
            </mat-form-field>-->
            </div>
        </div>

    </td>
</tr>
    
    
    
    
    
        
    
    
        
        <button style=" height: 32px;
                background-color: #3FA9F5;
                color: white;" class="confirm-ico-btn" mat-raised-button> 
                  <span class="fas fa-plus"></span> 
                  {{'SAVE' | translate}}
              </button>
    </table>
</div>
</form>
</div>
    